export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const ERROR_HANDLE = "ERROR_HANDLE";
export const CLEAR_ERROR = "CLEAR_ERROR";

export const FETCH_ALL = "FETCH_ALL";
export const HERO_FETCH = "HERO_FETCH";
export const STATS_FETCH = "STATS_FETCH";

export const FETCH = "FETCH";
export const LIKE = "LIKE";

export const HERO_GOLD_DE = "HERO_GOLD_DE";
export const HERO_GOLD_INC = "HERO_GOLD_INC";

export const HERO_DIAMOND_DE = "HERO_DIAMOND_DE";
export const HERO_DIAMOND_INC = "HERO_DIAMOND_INC";

export const STATS_STR_IN = "STATS_STR_IN";
export const STATS_DEX_IN = "STATS_DEX_IN";
export const STATS_INT_IN = "STATS_INT_IN";
export const STATS_STA_IN = "STATS_STA_IN";
export const STATS_SPI_IN = "STATS_SPI_IN";

export const FETCH_O_ITEMS = "FETCH_O_ITEMS";
export const CHANGE_ITEM = "CHANGE_ITEM";
export const CREATE_ITEM = "CREATE_ITEM";

export const FETCH_O_INVENTORY = "FETCH_O_INVENTORY";
export const DELETE_ITEM = "DELETE_ITEM";

export const FETCH_SKILLS = "FETCH_SKILLS";
export const CREATE_SKILLS = "CREATE_SKILLS";
export const CREATE_O_ITEMS = "CREATE_O_ITEMS";

export const ASSIGN_SKILLS = "ASSIGN_SKILLS";
export const UNLOCK_SKILLS = "UNLOCK_SKILLS";
export const HERO_AFTER_MISSION = "HERO_AFTER_MISSION";
export const ADD_POINT = "ADD_POINT";
export const CREATE_MISSIONS = "CREATE_MISSIONS";
export const SHOW_MISSIONS = "SHOW_MISSIONS";
export const NEW_MISSIONS = "NEW_MISSIONS";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";

export const CREATE_ALL_TRADE_ITEMS = "CREATE_ALL_TRADE_ITEMS";
export const FETCH_ALL_TRADE_ITEMS = "FETCH_ALL_TRADE_ITEMS";
export const UPDATE_ALL_TRADE_ITEMS = "UPDATE_ALL_TRADE_ITEMS";
export const UPDATE_ONE_TRADE_ITEMS = "UPDATE_ONE_TRADE_ITEMS";
export const DELETE_AND_ASSIGN_ITEM_TO_INVENTORY = "DELETE_AND_ASSIGN_ITEM_TO_INVENTORY";
export const SET_GAME = "SET_GAME";
export const SET_PLAYER = "SET_PLAYER";

export const CREATE_SKILLS_IN_BATTLE = "CREATE_SKILLS_IN_BATTLE";
export const GET_SKILLS_IN_BATTLE = "GET_SKILLS_IN_BATTLE";
export const ASSIGN_TO_SKILLS_IN_BATTLE = "ASSIGN_TO_SKILLS_IN_BATTLE";
export const UNASSIGN_TO_SKILLS_IN_BATTLE = "UNASSIGN_TO_SKILLS_IN_BATTLE";

export const CREATE_NEW_INVENTORY = "CREATE_NEW_INVENTORY";
export const GET_INVENTORY = "GET_INVENTORY";
export const ASSIGN_ITEM_TO_INVENTORY = "ASSIGN_ITEM_TO_INVENTORY";
export const DELETE_ITEM_FORM_INVENTORY = "DELETE_ITEM_FORM_INVENTORY";
export const CHANGE_ITEM_IN_INVENTORY = "CHANGE_ITEM_IN_INVENTORY";

export const CREATE_DUNGEONS = "CREATE_DUNGEONS";
export const SHOW_DUNGEONS = "SHOW_DUNGEONS";
export const NEW_DUNGEONS = "NEW_DUNGEONS";

export const CREATE_ROOM = "CREATE_ROOM";
export const SHOW_ROOMS = "SHOW_ROOMS";
export const SHOW_ROOM = "SHOW_ROOM";
export const SHOW_ROOM_BY_NAME = "SHOW_ROOM_BY_NAME";
export const JOIN_ROOM = "JOIN_ROOM";
export const DELETE_ROOM = "DELETE_ROOM";
export const LEAVE_ROOM = "LEAVE_ROOM";
export const SEND_UPDATE_ROOM_IN_GAME = "SEND_UPDATE_ROOM_IN_GAME";
export const DOWNLOAD_UPDATE_ROOM_IN_GAME = "DOWNLOAD_UPDATE_ROOM_IN_GAME";
